"use strict";

exports.__esModule = true;
exports.parseRouterData = parseRouterData;

var _lodash = require("lodash");

var _atob = _interopRequireDefault(require("../helpers/atob"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function parseRouterData(data) {
  try {
    return (0, _lodash.isObject)(data) ? data : JSON.parse(data);
  } catch (e) {
    return JSON.parse((0, _atob["default"])(data));
  }
}